import { DescriptorPreviewConfig } from '@agilelab/plugin-wb-builder-common';
import { configurationApiRef } from '@agilelab/plugin-wb-configuration-common';
import { useApi } from '@mainstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

export type BuilderEditAndTestDescriptorPreview =
  | DescriptorPreviewConfig
  | undefined;

export type BuilderEditAndTestDescriptorPreviewResult = {
  enabled: boolean;
  mode: 'customView' | 'yaml';
  loading: boolean;
  error: unknown;
};

export const BUILDER_EDIT_AND_TEST_DESCRIPTOR_PREVIEW_ENABLED_QUERY_KEY = [
  'builder',
  'editAndTestDescriptorPreview',
  'enabled',
];

export const useBuilderEditAndTestDescriptorPreview =
  (): BuilderEditAndTestDescriptorPreviewResult => {
    const wbConfigApi = useApi(configurationApiRef);
    const { data, isLoading, error } = useQuery<
      BuilderEditAndTestDescriptorPreview | undefined
    >({
      queryKey: BUILDER_EDIT_AND_TEST_DESCRIPTOR_PREVIEW_ENABLED_QUERY_KEY,
      queryFn: () =>
        wbConfigApi.get<BuilderEditAndTestDescriptorPreview>({
          namespace: 'builder',
          key: 'fe.editAndTest.descriptorPreview',
        }),
    });

    return useMemo(
      () => ({
        enabled: data?.enabled ?? true,
        mode: data?.defaultView ?? 'yaml',
        loading: isLoading,
        error,
      }),
      [data?.defaultView, data?.enabled, error, isLoading],
    );
  };
